import { Button, Widget, notification } from '@digital/ui';
import { Row, Modal, Icon } from 'antd';
import React, { useEffect, useState } from 'react';
import ModalAvancar from './ModalAvancar';
import ModalAprovacaoProponentes from './ModalAprovacaoProponentes';
import ModalRetornarFluxoProponentes from './ModalRetornarFluxoProponentes';
import { stepState, anteriorStepState, ordemCompraIdState, showModalDesobrigarConfideIdState, dadosGeraisState, reloadVendorListState, reloadWidgetTimelineState, reloadState, ordemCompraRodadaNegociacaoIdState, ajustarStepOnReloadState, reloadDadosGeraisState } from '../atoms';
import { useRecoilValue, useRecoilState, useSetRecoilState } from 'recoil';
import { isObjNotEmpty } from '@app/helpers/objHelper';
import { EGuidFluxoProcessoEtapa } from '@app/enums/EGuidFluxoProcessoEtapa';
import { Space, Visibility } from '@app/components';
import { ButtonModalEnviarConsolidacaoparaArea } from './ButtonModalEnviarConsolidacaoparaArea';
import { enviarEmailsRespostaConsolidacaoEsclarecimentos, notificarDemandanteCadastroNovaRodada, verificarNecessidadeCadastroNovaRodada } from '@app/api/sas/sasProposta';
import { ButtonModalEnviarPropostaTecnica } from './ButtonModalEnviarPropostaTecnica';
import { baixarProponentesSemConfide, getIsAjusteOrcamentario } from '@app/api/sas/ordemCompra';
import { ButtonModalDefinirVencedor } from './ButtonModalDefinirVencedor';
import { ModalAprovarCES } from '../WidgetAcompanhamentoProcesso/ModalAprovarCES';
import { isValidGuid } from '@app/helpers/geradorGuid';
import ModalEnvioCartaConvite from '../WidgetAcompanhamentoProcesso/ModalEnvioCartaConvite';
import ModalConfirmarHandover from '../WidgetDocumentacao/ModalConfirmarHandover';
import ModalGerarContratoTotvs from '../AbaRelatorioHomologacao/ModalGerarContratoTotvs';
import { enviarParaAprovacao } from '@app/api/sas/relatorioHomologacao';
import ButtonModalEnviarDdi from './ButtonModalEnviarDdi';
import ButtonModalEnvioCartaAgradecimento from './ButtonModalEnvioCartaAgradecimento';
import ModalEmitirContrato from './ModalEmitirContrato';
import { ETipoDemanda } from '@app/enums/ETipoDemanda';
import ModalNotificarVencedorAreaTecnica from '../WidgetAcompanhamentoProcesso/ModalNotificarVencedorAreaTecnica';
import { ETipoContrato } from '@app/enums/ETipoContrato';
import ModalEmitirPCS from './ModalEmitirPCS';
import { parametrosSasState } from '@app/atoms';
import AjusteOrcamentario from '../AjusteOrcamentario';
import { EStatusAprovacaoContratoTotvs } from '@app/enums';
import ButtonModalDesobrigarDdi from './ButtonModalDesobrigarDdi';
import { ButtonModalAtivarDemanda } from './ButtonModalAtivarDemanda';

interface Props {
}

const WidgetActions = (props: Props) => {
  const [step, setStep] = useRecoilState(stepState);
  const anteriorStep = useRecoilValue(anteriorStepState);
  const [reload, setReload] = useRecoilState(reloadState);
  const [reloadVendorList, setReloadVendorList] = useRecoilState(reloadVendorListState);
  const [reloadWidgetTimeline, setReloadWidgetTimeline] = useRecoilState(reloadWidgetTimelineState);
  const [reloadDadosGerais, setReloadDadosGerais] = useRecoilState(reloadDadosGeraisState);
  const showDesobrigarId = useRecoilValue(showModalDesobrigarConfideIdState);
  const ordemCompraId = useRecoilValue(ordemCompraIdState);
  const dadosGerais = useRecoilValue(dadosGeraisState);
  const setOrdemCompraRodadaNegociacaoId = useSetRecoilState(ordemCompraRodadaNegociacaoIdState);
  const [exibirModalAprovacaoProponentes, setExibirModalAprovacaoProponentes] = useState(false);
  const [exibirModalRetornarFluxoProponentes, setExibirModalRetornarFluxoProponentes] = useState(false);
  const [statusAnterior, setStatusAnterior] = useState('');
  const setAjustarStepOnReload = useSetRecoilState(ajustarStepOnReloadState);
  const ehAditivo = dadosGerais.tipo === ETipoDemanda.Aditivo;
  const ehFaturamentoDireto = dadosGerais.tipo === ETipoDemanda.FaturamentoDireto;
  const ehAditivoContrato = ehAditivo && dadosGerais.tipoContrato && dadosGerais.tipoContrato.toLowerCase() === "contrato";
  const aditivoComIntegracaoTotvs = dadosGerais.isPrazo || dadosGerais.isValorSemAcrescimoEscopo;
  const tipoContrato = dadosGerais.modalidadeContratoTotvs || dadosGerais.tipoContrato || '';
  const ehPCS = tipoContrato.toLowerCase() === ETipoContrato.PCS;
  const parametrosSas = useRecoilValue(parametrosSasState);
  const [disableEnvioAprovacao, setDisableEnvioAprovacao] = useState(false);

  const onReload = () => {
    setReloadWidgetTimeline(!reloadWidgetTimeline);
    setReloadVendorList(!reloadVendorList);
    setReloadDadosGerais(!reloadDadosGerais);
    setReload(!reload);
  };

  const handleBotaoVoltar = () => {
    setOrdemCompraRodadaNegociacaoId(anteriorStep.ordemCompraRodadaNegociacaoId);
    setStep({ ...anteriorStep });
  };

  const handleRespostaConsolidacaoEsclarecimentos = () => {
    Modal.confirm({
      title: 'Enviar Resposta de Esclarecimentos',
      icon: <Icon type="info-circle" />,
      content: "Deseja enviar as respostas dos esclarecimentos para todos os proponentes?",
      onOk() {
        Modal.confirm({
          title: 'Confirmação Envio de Email',
          content:
            'Você deseja enviar este e-mail?',
          cancelText: 'Não',
          onCancel: () => {
            enviarEmailsRespostaConsolidacaoEsclarecimentos(ordemCompraId, false).then((response: any) => {
              if (response && response.valid) {
                onReload();
              }
            });
          },
          okText: 'Sim',
          onOk: () => {
            enviarEmailsRespostaConsolidacaoEsclarecimentos(ordemCompraId, true).then((response: any) => {
              if (response && response.valid) {
                onReload();
              }
            });
          },
        });
      },
      onCancel() { },
    });
  };

  const handleBaixarProponentesSemConfide = () => {
    baixarProponentesSemConfide(ordemCompraId);
  };

  const handleReloadCadastrarNovaRodada = () => {
    setAjustarStepOnReload(true);
    setReloadDadosGerais(!reloadDadosGerais);
    onReload();
  };

  const handleCadastrarNovaRodada = () => {
    verificarNecessidadeCadastroNovaRodada(ordemCompraId)
      .then((response: any) => {
        if (response && response.valid) {
          notification.success('Item cadastrado com sucesso.');
          if (response.mensagem) {
            Modal.confirm({
              title: 'Notificar demandante',
              icon: <Icon type="info-circle" />,
              content: response.mensagem,
              okText: 'Sim',
              onOk: () => {
                notificarDemandanteCadastroNovaRodada(ordemCompraId)
                  .then((response: any) => {
                    if (response && response.valid) {
                      handleReloadCadastrarNovaRodada();
                    }
                  });
              },
              cancelText: 'Não',
              onCancel: () => {
                handleReloadCadastrarNovaRodada();
              },
            });
          } else {
            handleReloadCadastrarNovaRodada();
          }
        }
      });
  };

  const handleEnviarAprovacao = () => {
    enviarParaAprovacao(ordemCompraId).then(data => {
      if (data) {
        onReload();
      }
    });
  };

  return (
    <div style={{ paddingBottom: '64px' }}  >

          {(step && isObjNotEmpty(step) && 'fluxoEtapaId' in step) && (
        <Widget>
          <Row type='flex' justify='end'>
            <Visibility visible={
              step.fluxoEtapaId == EGuidFluxoProcessoEtapa.AnalisePropostasComerciaisCadastroRodadasNegociacoes ||
              step.fluxoEtapaId == EGuidFluxoProcessoEtapa.RecebimentoPropostaComercial ||
              step.fluxoEtapaId == EGuidFluxoProcessoEtapa.FluxoGenericoRodadaNegociacao
            }>
              
              <Visibility visible={!dadosGerais.consultiva}>
                <AjusteOrcamentario />
                <Space mr={8} />
              </Visibility>
            </Visibility>

            {
              dadosGerais && dadosGerais.tipo == ETipoDemanda.FaturamentoDireto ? 
              (<>
              <Visibility visible={
              dadosGerais &&
              'fluxoEtapaId' in step && isObjNotEmpty(step.fluxoEtapaId) &&
              step.fluxoEtapaId == EGuidFluxoProcessoEtapa.ElaboracaoaprovacaoRH} >
              <Button 
                title='Enviar para aprovação'
                disabled={
                  !dadosGerais.necessitaEnviarAprovacao
                }
                className='button-sas-acoes'
                type='primary'
                onClick={handleEnviarAprovacao}
              />
              <Space mr={8} />
            </Visibility>
            </>) :
              (<><Visibility visible={
              dadosGerais &&
              // dadosGerais.relatorioEnviarAprovacao === true &&
              // isObjEmptyOrSpaces(dadosGerais.statusAprovacaoRelatorioHomologacaoSas) &&
              'fluxoEtapaId' in step && isObjNotEmpty(step.fluxoEtapaId) &&
              step.fluxoEtapaId == EGuidFluxoProcessoEtapa.ElaboracaoaprovacaoRH} >
              <Button 
                title='Enviar para aprovação'
                disabled={
                  !dadosGerais.necessitaEnviarAprovacao || 
                  (parametrosSas.sasValorMaximoGerenteGeralHabilitado === false
                    || dadosGerais.valorCalcRH >= parametrosSas.sasValorMaximoGerenteGeral) && 
                  (parametrosSas.sasValorMaximoGerenteDepartamentoHabilitado === false
                    || dadosGerais.valorCalcRH >= parametrosSas.sasValorMaximoGerenteDepartamento)
                }
                className='button-sas-acoes'
                type='primary'
                onClick={handleEnviarAprovacao}
              />
              <Space mr={8} />
            </Visibility>
          </>)

            }
            

            <Visibility
              visible={
                'fluxoEtapaId' in step && isObjNotEmpty(step.fluxoEtapaId) &&
                step.fluxoEtapaId == EGuidFluxoProcessoEtapa.GerarContratoPCSTotvs
              }
            >
              <ModalGerarContratoTotvs ordemCompraId={ordemCompraId} />
              <Space mr={8} />
            </Visibility>

            <Visibility
              visible={
                'fluxoEtapaId' in step && isObjNotEmpty(step.fluxoEtapaId) &&
                step.fluxoEtapaId == EGuidFluxoProcessoEtapa.GerarContratoPCSTotvs && ehPCS} 
            >
              <ModalEmitirPCS />
              <Space mr={8} />
            </Visibility>

            <Visibility
              visible={
                'fluxoEtapaId' in step && isObjNotEmpty(step.fluxoEtapaId) &&
                step.fluxoEtapaId == EGuidFluxoProcessoEtapa.EnvioDaCartaConvite &&
                dadosGerais && dadosGerais.tipo != ETipoDemanda.Aditivo
              }
            >
              <ModalEnvioCartaConvite />
            </Visibility>

            <Visibility
              visible={dadosGerais &&
                'fluxoEtapaId' in step && isObjNotEmpty(step.fluxoEtapaId) &&
                step.fluxoEtapaId == EGuidFluxoProcessoEtapa.HandoverContrato &&
                (!ehAditivoContrato || aditivoComIntegracaoTotvs) && !ehPCS}
            >
              <ModalEmitirContrato />
              <Space mr={8} />
            </Visibility>

            <Visibility
              visible={dadosGerais &&
                'fluxoEtapaId' in step && isObjNotEmpty(step.fluxoEtapaId) &&
                step.fluxoEtapaId == EGuidFluxoProcessoEtapa.HandoverContrato}
            >
              <ModalConfirmarHandover />
              <Space mr={8} />
            </Visibility>

            <Visibility
              visible={
                'fluxoEtapaId' in step && isObjNotEmpty(step.fluxoEtapaId) &&
                step.fluxoEtapaId == EGuidFluxoProcessoEtapa.EnviaCartaAgradecimento}
            >
              <Visibility
                visible={!ehFaturamentoDireto}
              >
              <ButtonModalEnvioCartaAgradecimento disabled={step.isRealizado || (ehAditivo && ehPCS)} />
              <Space mr={8} />
              </Visibility>
              
              <Visibility
                visible={dadosGerais.tipo === ETipoDemanda.NovaContratacao || (ehAditivo && ehPCS ) || ehFaturamentoDireto}
              >
                <ModalNotificarVencedorAreaTecnica />
                <Space mr={8} />
              </Visibility>
            </Visibility>

            <Visibility
              visible={
                'fluxoEtapaId' in step && isObjNotEmpty(step.fluxoEtapaId) &&
                step.fluxoEtapaId == EGuidFluxoProcessoEtapa.ConclusaoDoProcessoStep}>
              <ModalNotificarVencedorAreaTecnica />
              <Space mr={8} />
            </Visibility>


            <Visibility
              visible={'fluxoEtapaId' in step && isObjNotEmpty(step.fluxoEtapaId) &&
                step.fluxoEtapaId == EGuidFluxoProcessoEtapa.EnvioInformaçõesAdmContratosProvidenciarCES
                // && hasPermissionPerfil([EGuidPerfilAcesso.ResponsavelCES])
              }
            >
              <ModalAprovarCES />
              <Space mr={8} />
            </Visibility>

            <Visibility
              visible={
                'fluxoEtapaId' in step && isObjNotEmpty(step.fluxoEtapaId) &&
                (step.fluxoEtapaId == EGuidFluxoProcessoEtapa.AnalisePropostasComerciaisCadastroRodadasNegociacoes
                  || step.fluxoEtapaId == EGuidFluxoProcessoEtapa.FluxoGenericoRodadaNegociacao
                  || isValidGuid(showDesobrigarId))
              }
            >
              <Visibility visible={dadosGerais.consultiva}>
                <ButtonModalAtivarDemanda/>
                <Space mr={8} />
              </Visibility>

              <Button
                title='Cadastrar Nova Rodada'
                type='primary'
                onClick={handleCadastrarNovaRodada}
              />
              <Space mr={8} />

              <Visibility visible={!dadosGerais.consultiva}>
                  <ButtonModalDefinirVencedor />
                  <Space mr={8} />
              </Visibility>
            </Visibility>


            <Visibility
              visible={'fluxoEtapaId' in step && isObjNotEmpty(step.fluxoEtapaId) &&
                step.fluxoEtapaId == EGuidFluxoProcessoEtapa.EnvioPropostaTecnicaAreaRequisitante}
            >
              <ButtonModalEnviarPropostaTecnica />
              <Space mr={8} />
            </Visibility>

            <Visibility
              visible={'fluxoEtapaId' in step && isObjNotEmpty(step.fluxoEtapaId) &&
                step.fluxoEtapaId == EGuidFluxoProcessoEtapa.RecebimentoEsclarecimentosTecnicosAreaRequisitanteEnvioProponentes}
            >
              <Button
                title='Enviar Resposta de Esclarecimentos'
                type='primary'
                onClick={() => handleRespostaConsolidacaoEsclarecimentos()}
              />
              <Space mr={8} />
            </Visibility>

            <Visibility
              visible={'fluxoEtapaId' in step && isObjNotEmpty(step.fluxoEtapaId) &&
                step.fluxoEtapaId == EGuidFluxoProcessoEtapa.ConsolidacaoEsclarecimentosTecnicosEnvioAreaRequisitante}
            >
              <ButtonModalEnviarConsolidacaoparaArea />
              <Space mr={8} />
            </Visibility>

            <Visibility
              visible={'fluxoEtapaId' in step && isObjNotEmpty(step.fluxoEtapaId) &&
                step.fluxoEtapaId == EGuidFluxoProcessoEtapa.SolicitacaoDDI}
            >
              <ButtonModalEnviarDdi />
              <Space mr={8} />
              <ButtonModalDesobrigarDdi />
              <Space mr={8} />
            </Visibility>

            <Visibility visible={'fluxoEtapaId' in step && isObjNotEmpty(step.fluxoEtapaId) &&
              step.fluxoEtapaId == EGuidFluxoProcessoEtapa.SolicitacaoCONFIDE}  >
              <Button title='Baixar Proponentes Sem Relatório Financeiro' type='primary' onClick={() => handleBaixarProponentesSemConfide()} />
              <Space mr={8} />
            </Visibility>
             <Visibility visible={step.ordem > 21 && !ehFaturamentoDireto}>
                <Button
                  disabled={dadosGerais.statusAprovacaoContratoTotvs === EStatusAprovacaoContratoTotvs.APROVADO || dadosGerais.statusAprovacaoContratoTotvs === EStatusAprovacaoContratoTotvs.EMITIDO}
                  className='button-sas-acoes'
                  title='retornar propostas comerciais'
                  type='primary'
                  onClick={() => {
                    setStatusAnterior(step.nome); 
                    setExibirModalRetornarFluxoProponentes(true); 
                  }}
                />
              <Space mr={8}/>
            </Visibility>           
            <Visibility
              visible={
                isObjNotEmpty(anteriorStep)
                && isObjNotEmpty(anteriorStep.fluxoEtapaId)
                && 'fluxoEtapaId' in anteriorStep && isObjNotEmpty(anteriorStep.fluxoEtapaId)
                && step.fluxoEtapaId != EGuidFluxoProcessoEtapa.AnaliseDocumentacao
              }
            >
              <Button
                title='Voltar'
                type='danger'
                onClick={() => handleBotaoVoltar()}
              />
              <Space mr={8} />
            </Visibility>
            <ModalAvancar
              setExibirModalAprovacaoProponentes={setExibirModalAprovacaoProponentes}
            />
          </Row>
        </Widget>
      )}

      <ModalAprovacaoProponentes exibirModal={exibirModalAprovacaoProponentes} setExibirModal={setExibirModalAprovacaoProponentes} />
      <ModalRetornarFluxoProponentes
        exibirModal={exibirModalRetornarFluxoProponentes}
        setExibirModal={setExibirModalRetornarFluxoProponentes}
        statusAnterior={statusAnterior}
        setStatusAnterior={setStatusAnterior}
      />


    </div>
  );
};

export default WidgetActions;